module.exports = __webpack_public_path__ + "static/media/fb.03309f67.svg";